import { useParams } from "react-router-dom";
import QuizItem from "./QuizItem";

const QuizList = ({ quizzes, isLoading, isError }) => {
  // decide what to render
  let content = "";

  if (isLoading) {
    content = <div className="text-center">Loading...</div>;
  }

  if (!isLoading && isError) {
    content = (
      <div className="text-center text-red-500">Internal server error!</div>
    );
  }

  if (!isLoading && !isError && quizzes?.length === 0) {
    content = <div className="text-center">No quizzes found!</div>;
  }

  if (!isLoading && !isError && quizzes?.length > 0) {
    content = quizzes.map((quiz, index) => (
      <QuizItem key={quiz.id} quiz={quiz} questionId={quiz.id} i={index} />
    ));
  }

  return <div className="space-y-8 ">{content}</div>;
};

export default QuizList;
